

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
// import { isFunction } from 'lodash';
// import { ConfigTiposAlerta } from '@/pantallas/Camaras/Alertas/fetchTipoAlerta';
// import { AlertaWidget } from '@/pantallas/Camaras/Alertas/fetchWidgets';

import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import moment from 'moment';

@Component({
  components: {},
})
export default class WidgetAlerta extends Vue {
  @Prop() listaAlertasWidgets: any[];

  constructor() {
    super();
  }
  async mounted() {}
  filterWidget(tipo: any) {
    this.$emit('filtroWidget', tipo);
  }

  filterAlert(text: string): string {
    return text.replace('_', ' ');
  }
}
